import styled from 'styled-components';
import { EditorContent } from '@tiptap/react';
import { theme } from '../../../styles/theme';
import EmojiPicker from './EmojiPicker';

export const Container = styled.div`
  flex: 1;
  border-radius: 4px;
  background-color: ${theme.colors.level0};
`;
export const InputWrapper = styled.div`
  min-height: 48px;
  padding: 8px 12px;
`;
export const StyledEditor = styled(EditorContent)`
  .ProseMirror {
    position: static;
  }

  .ProseMirror:focus {
    outline: none;
  }

  .tiptap {
    padding: 0;
    font-size: 12px;
    font-weight: 400;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    color: ${theme.colors.secondary900};

    p.is-editor-empty:first-child::before {
      color: ${theme.colors.secondary600};
      content: attr(data-placeholder);
      float: left;
      height: 0;
      pointer-events: none;
    }
  }

  [data-type='mention'] {
    color: ${theme.colors.mainBlue};
  }

  [data-type='emoji'] {
    user-select: text;
    // font-family needs to be inorder as firefox differ from chrome
    font-family: 'Twemoji Mozilla', 'Apple Color Emoji', 'Segoe UI Emoji',
      'Segoe UI Symbol', 'Noto Color Emoji', 'EmojiOne Color', 'Android Emoji',
      sans-serif;
  }
`;
export const Footer = styled.div`
  display: flex;
  padding: 8px 12px;
  border-top: 1px solid ${theme.colors.border};
`;
export const FooterActions = styled.div`
  flex: 0 0 auto;
  display: flex;
  column-gap: 8px;
  margin-right: auto;
`;
export const ActionsWrapper = styled.div`
  flex: 0 0 auto;
  display: inline-flex;
  column-gap: 4px;
`;
export const StyledEmojiPicker = styled(EmojiPicker)`
  flex: 0 0 auto;
  width: 20px;
  height: 20px;
`;
